__turbopack_context__.v({
  "auxInfo": "PriceFilter-module__4fAEaq__auxInfo",
  "discountSwitch": "PriceFilter-module__4fAEaq__discountSwitch",
  "financeProduct": "PriceFilter-module__4fAEaq__financeProduct",
  "listItem": "PriceFilter-module__4fAEaq__listItem",
  "priceFilter": "PriceFilter-module__4fAEaq__priceFilter",
  "priceTypeBtns": "PriceFilter-module__4fAEaq__priceTypeBtns",
  "resultCount": "PriceFilter-module__4fAEaq__resultCount",
});
